import dayjs from '@seolens/date-manager';
import { TableProps } from 'antd';
import { ColumnType } from 'antd/es/table';
import { CaretDownFill, CaretUpFill } from 'react-bootstrap-icons';

import { SearchConsoleAnalyticsDimensionsKeys, SearchConsoleAnalyticsRowKeysColor } from '@/modules/Domains';

import { parseNumberValue } from '../../helpers';
import { TableKeyValueLableHoc } from './DimensionTableKeyValueLables';

const rowTitles: Record<SearchConsoleAnalyticsDimensionsKeys, string> = {
  countries: 'Країна',
  devices: 'Пристрій',
  pages: 'Найпопулярніші сторінки',
  queries: 'Найпопулярніші запити',
  searchAppearances: 'Вигляд у пошуку',
  dates: 'Дата',
};

const columns: (args: {
  dimension: SearchConsoleAnalyticsDimensionsKeys;
  itemsColor: SearchConsoleAnalyticsRowKeysColor;
}) => TableProps['columns'] = ({ dimension, itemsColor }) => [
  {
    title: rowTitles[dimension],
    dataIndex: 'keyValue',
    key: 'keyValue',
    render: (value) => <TableKeyValueLableHoc dimension={dimension} value={value} />,
    sorter: (a, b) => {
      if (dayjs(new Date(a.key)).isValid() && dayjs(new Date(b.key)).isValid()) {
        return new Date(a.key).getTime() - new Date(b.key).getTime();
      } else {
        return a.keyValue.localeCompare(b.keyValue);
      }
    },
    sortIcon: sortIconRender,
  },
  {
    title: 'Звертання',
    dataIndex: 'clicks',
    key: 'clicks',
    width: 145,
    align: 'end',
    render: (value: number) => <span style={{ color: itemsColor.clicks }}>{parseNumberValue(value, false, false)}</span>,
    sorter: (a, b) => a.clicks - b.clicks,
    defaultSortOrder: 'descend',
    sortIcon: sortIconRender,
  },
  {
    title: 'Покази',
    dataIndex: 'impressions',
    key: 'impressions',
    width: 145,
    align: 'end',
    render: (value: number) => <span style={{ color: itemsColor.impressions }}>{parseNumberValue(value, false, false)}</span>,
    sorter: (a, b) => a.impressions - b.impressions,
    sortIcon: sortIconRender,
  },
  {
    title: 'CTR',
    dataIndex: 'ctr',
    key: 'ctr',
    width: 145,
    align: 'end',
    render: (value: number) => <span style={{ color: itemsColor.ctr }}>{parseNumberValue(value, true, false)}</span>,
    sorter: (a, b) => a.ctr - b.ctr,
    sortIcon: sortIconRender,
  },
  {
    title: 'Позиція',
    dataIndex: 'position',
    key: 'position',
    width: 145,
    align: 'end',
    render: (value: number) => <span style={{ color: itemsColor.position }}>{parseNumberValue(value, false, false)}</span>,
    sorter: (a, b) => a.position - b.position,
    sortIcon: sortIconRender,
  },
];

export default columns;

const sortIconRender: ColumnType<unknown>['sortIcon'] = ({ sortOrder }) => {
  return (
    <>
      <span className="ant-table-column-sorter ant-table-column-sorter-full">
        <span className="ant-table-column-sorter-inner" aria-hidden="true">
          <span
            style={{ height: 12 }}
            role="img"
            aria-label="caret-up"
            className={`anticon-caret-up ant-table-column-sorter-up  ${sortOrder === 'ascend' ? 'active' : ''}`}
          >
            <CaretUpFill size={12} />
          </span>
          <span
            style={{ height: 12 }}
            role="img"
            aria-label="caret-up"
            className={`anticon-caret-down ant-table-column-sorter-down ${sortOrder === 'descend' ? 'active' : ''}`}
          >
            <CaretDownFill size={12} />
          </span>
        </span>
      </span>
    </>
  );
};
